import { Helmet } from "react-helmet-async"
import { SupplierPayments } from "../../../../../Supplier"
import { useParams } from "../../../../../router-utils"

export default function TransportServiceProviderPaymentsPage() {
	const { supplierId } = useParams("/suppliers/:supplierId/payments/outgoing")
	return (
		<>
			<Helmet>
				<title>Outgoing Payments | Suppliers</title>
			</Helmet>
			<SupplierPayments supplierId={supplierId} paymentType="debit" />
		</>
	)
}
